module.exports = __webpack_public_path__ + "img/1479492100.d92d24fb.jpg";